import { feCommonDataHolder } from '@lastbrand/fe-common'

import { FALLBACK_LOCALE, LOCALE_COOKIE } from '@src/config/localisation/locale-config.constants'
import getCookie from '@src/quince-site-common/src/utils/getCookie'
import { shouldEnableI18nClient } from '@src/server-side/utils/i18n-preview.utils'

const env = process.env.NEXT_PUBLIC_FE_COMMON_ENV ?? 'PROD'

export const initializeFeCommon = () => {
  const locale = getCookie(LOCALE_COOKIE) ?? FALLBACK_LOCALE

  ;(
    feCommonDataHolder as {
      initialize: (options: { env: string; flags: { enableI18n: boolean }; locale: string }) => void
    }
  ).initialize({
    env,
    flags: {
      enableI18n: shouldEnableI18nClient(),
    },
    locale,
  })
}
